import { all, put, takeEvery, select, call } from 'redux-saga/effects'
import ReportActions, { getOpenDailyReport } from './actions'
import { getClinicDailyReport, reportSetState } from '../actions'
import { notification, analytics } from '../../services/index'

const getClinic = (state) => state.clinic

export function* GET_OPEN_DAILY_REPORT({ payload }) {
  yield put(reportSetState({ loading: true, openDailyReports: { data: [], info: {} } }))
  const response = yield call(getOpenDailyReport, payload)
  yield put(reportSetState({ loading: false, openDailyReports: response }))
}
export function* GET_CLINIC_DAILY_REPORT({ payload }) {
  yield put(reportSetState({ loading: true, dailyReport: [] }))
  const { userClinic } = yield select(getClinic)
  payload.clinic_id = userClinic.id
  let data = yield call(getClinicDailyReport, payload)

  if (data.length > 0) {
    if (payload.floor && payload.floor !== 'all') {
      data = data.filter((item) => item.floor_id === parseInt(payload.floor, 10))
    }
  }
  const isReportGenerated = !(data.length === 0)
  if (!isReportGenerated) {
    notification.error(`Report could not be generated`, `No data was available for this date`)
  }

  yield put(reportSetState({ loading: false, dailyReport: data, isReportGenerated }))

  analytics.event({
    action: 'get_clinic_daily_report',
    category: 'clinical_reports',
    label: 'Generate Report',
    value: payload,
  })
}

// Assigning constant Strings to Saga Functions, in order to access Saga Functions from Redux
export default function* rootSaga() {
  yield all([
    takeEvery(ReportActions.GET_CLINIC_DAILY_REPORT, GET_CLINIC_DAILY_REPORT),
    takeEvery(ReportActions.GET_OPEN_DAILY_REPORT, GET_OPEN_DAILY_REPORT),
  ])
}
